<div class="input-group">
  <ng-template #t let-date let-focused="focused">
    <span
      class="custom-day"
      [class.focused]="focused"
      [class.range]="isRange(date)"
      [class.faded]="isHovered(date) || isInside(date)"
      (mouseenter)="hovered = date"
      (mouseleave)="hovered = null">
      {{ date.day }}
    </span>
  </ng-template>
  <input
    #dpFromDate
    class="form-control"
    placeholder="MM-DD-YYYY"
    name="dpFromDate"
    (click)="datepicker.toggle()"
    [value]="format(from)"
    (input)="(dpFromDate.value)" />
  <input
    width="1%"
    name="datepicker"
    class="form-control position-absolute invisible"
    ngbDatepicker
    #datepicker="ngbDatepicker"
    [autoClose]="'outside'"
    (dateSelect)="dateSelect($event, datepicker)"
    [displayMonths]="2"
    [dayTemplate]="t"
    outsideDays="hidden"
    [startDate]="from!"
    tabindex="-1" />
  <span class="input-group-text">To</span>
  <input
    #dpToDate
    class="form-control"
    placeholder="MM-DD-YYYY"
    name="dpToDate"
    (click)="datepicker.toggle()"
    [value]="format(to)"
    (input)="(dpToDate.value)" />
  <button
    class="btn btn-outline-secondary bi bi-calendar3"
    (click)="datepicker.toggle()"
    type="button">
    <i class="bx bx-calendar me-1"></i>
  </button>
</div>
